"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marshallJob = exports.marshallUser = exports.isJobItemArray = exports.isJobItem = exports.isUserItem = exports.isItem = void 0;
const _1 = require("./");
const types_1 = require("./types");
const utils_1 = require("./utils");
function isItem(arg) {
    return ((0, _1.isObject)(arg) &&
        "PK" in arg &&
        typeof arg.PK === "string" &&
        "SK" in arg &&
        typeof arg.SK === "string");
}
exports.isItem = isItem;
function isUserItem(arg) {
    return ((0, _1.isObject)(arg) &&
        "PK" in arg &&
        typeof arg.PK === "string" &&
        arg.PK.slice(0, 2) === "U:" &&
        "SK" in arg &&
        typeof arg.SK === "string" &&
        arg.SK === "Details");
}
exports.isUserItem = isUserItem;
function isJobItem(arg) {
    return ((0, _1.isObject)(arg) &&
        "PK" in arg &&
        typeof arg.PK === "string" &&
        arg.PK.slice(0, 2) === "U:" &&
        "SK" in arg &&
        typeof arg.SK === "string" &&
        arg.SK.slice(0, 2) === "J:");
}
exports.isJobItem = isJobItem;
function isJobItemArray(arg) {
    return arg
        .map((item) => (0, _1.isObject)(item) &&
        "PK" in item &&
        typeof item.PK === "string" &&
        item.PK.slice(0, 2) === "U:" &&
        "SK" in item &&
        typeof item.SK === "string" &&
        item.SK.slice(0, 2) === "J:")
        .every((val) => val);
}
exports.isJobItemArray = isJobItemArray;
function marshallUser(item) {
    if (isUserItem(item)) {
        const { PK, SK, ...rest } = item;
        return {
            userId: PK.slice(2),
            ...(0, utils_1.convertAttributeNames)(rest, utils_1.pascalToCamel),
        };
    }
    throw types_1.ValidationError;
}
exports.marshallUser = marshallUser;
function marshallJob(item, createdBy) {
    if (isJobItem(item)) {
        const { SK, PK, ...rest } = item;
        const job = {
            jobId: SK.slice(2),
            createdBy,
            ...(0, utils_1.convertAttributeNames)(rest, utils_1.pascalToCamel),
        };
        return job;
    }
    throw types_1.ValidationError;
}
exports.marshallJob = marshallJob;
